import React from 'react';
import { Paper, Grid } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import useStyles from './LoanBorrower.styles';

const LoanBorrowerSkeleton = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.skeletonContainer}>
      <Grid container align="center">
        <Grid item xs={12}>
          <Skeleton height={48} width="90%" className={classes.skeleton} />
        </Grid>
      </Grid>

      <Grid container align="center">
        <Grid item xs={6}>
          <Skeleton height={80} width="80%" className={classes.skeleton} />
        </Grid>
        <Grid item xs={6}>
          <Skeleton height={80} width="80%" className={classes.skeleton} />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default LoanBorrowerSkeleton;
